import React, { useEffect, useState } from 'react'
import Drawer from 'components/Drawer'
import { Form, FlexWrap } from 'components/UIComponents/FormStyles'
import AddUserForm from 'modules/Users/Partials/AddUserDrawer/Partials/AddUserForm'
import Button from 'components/Button/index'
import CheckIconWhite from 'components/icons/CheckIconWhite'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import { Spinner } from 'modules/Users/Style/style'
import Flex from 'components/Flex'
import { removeDuplicatesFromArray } from 'utils/removeDuplicatesFromArray'
const AddUserDrawer = ({
  addUserDrawer,
  setAddUserDrawer,
  userRole,
  createUser,
  updateUser,
  singleUserData,
  userId,
  getUserData,
  form,
  updateLoading,
  getListOfCountries,
  sendNotificationEmail,
  editTemplate,
}) => {
  const [loading, setLoading] = useState(false)
  const [countryCodeSearch, setCountryCodeSearch] = useState('')
  const [countryCodeList, setCountryCodeList] = useState([])

  useEffect(() => {
    form.setFieldsValue({
      email: singleUserData?.email,
      phoneNumber: singleUserData?.phone_number,
      adminRoleId: singleUserData?.admin_role_id ?? singleUserData?.role_id,
      corporateId: singleUserData?.corporateId,
      firstName: singleUserData?.first_name,
      lastName: singleUserData?.last_name,
      countryCode: singleUserData?.country_code,
    })
  }, [singleUserData])

  const getCurrency = async ({ setState, searchValue }) => {
    const { data, status } = await getListOfCountries({
      phoneCodeSearch: searchValue.trim(),
      pageLimit: 500,
    })

    if (status >= 200 && status <= 300) {
      setState(removeDuplicatesFromArray(data?.data?.result, 'phone_code'))
    }
  }

  useEffect(() => {
    let getData
    if (countryCodeSearch) {
      getData = setTimeout(() => {
        getCurrency({
          setState: setCountryCodeList,
          searchValue: countryCodeSearch,
        })
      }, 500)
    } else {
      getCurrency({
        setState: setCountryCodeList,
        searchValue: countryCodeSearch,
      })
    }

    return () => clearTimeout(getData)
  }, [countryCodeSearch])

  const onCreateUser = async value => {
    let payLoadValue = {
      ...value,
      email: value?.email.trim()
    }
    let isEdit = !!singleUserData?._id
    setLoading(true)
    let response = !isEdit
      ? await createUser({ payload: payLoadValue })
      : await updateUser({ userId, payload: payLoadValue })

    if (response?.status == 201 || response?.status == 200 && response?.status) {
      SuccessMessage(
        isEdit ? 'User updated successfully!' : 'User created successfully!'
      )
      if (isEdit && editTemplate) {
        let name = value?.firstName + ' ' + value?.lastName
        let data = value?.phoneNumber + ' / ' + value?.email
        let template
        template = editTemplate?.templateText
          .replace('{UserName}', name)
          .replace('{Mobile_no/email}', data)
        let mailObj = {
          to: payLoadValue?.email,
          subject: 'Your  Account  is Update - Pluginlive',
          htmlBody: template,
        }
        sendNotificationEmail(mailObj)
      }
      setLoading(false)
      setAddUserDrawer(false)
      getUserData()
      form.resetFields()
    } else {
      ErrorMessage(response?.data?.message)
      setLoading(false)
    }
  }

  const onClose = () => {
    setAddUserDrawer(false)
    form.resetFields()
  }

  const content = () => {
    return (
      <>
        {updateLoading && (
          <Flex center>
            <Spinner />
          </Flex>
        )}
        <Form
          scrollToFirstError
          id={'addUserForm'}
          form={form}
          layout="vertical"
          onFinish={onCreateUser}
        >
          <AddUserForm
            userRole={userRole}
            countryCodeSearch={countryCodeSearch}
            setCountryCodeSearch={setCountryCodeSearch}
            countryCodeList={countryCodeList}
          />
        </Form>
      </>
    )
  }

  const footer = () => {
    return (
      <FlexWrap gap="20px" right>
        <Button.Secondary text="Cancel" height="38px" onClick={onClose} />
        <Button.Primary
          text={singleUserData?._id ? 'Update' : 'Send Invite'}
          htmlType="submit"
          form={'addUserForm'}
          icon={<CheckIconWhite />}
          height="38px"
          loading={loading}
        />
      </FlexWrap>
    )
  }

  return (
    <Drawer
      width="40%"
      title={singleUserData?._id ? 'Edit User' : 'Create New User'}
      placement="right"
      padding="30px"
      headerpadding="16px 30px"
      closable
      onClose={onClose}
      visible={addUserDrawer}
      content={content()}
      footer={footer()}
    />
  )
}

export default AddUserDrawer
